<template>
    <div>
        <!-- <pull-to class="evaluation-page" :top-load-method="downRefreshTwo" :bottom-load-method="upRefreshTwo" :is-bottom-bounce="true" bottom-block-height:0 top-block-height:0> -->
        <PullRefresh class="evaluation-page" v-model="bIsLoading" @refresh="onRefresh">
            <List v-model="isLoading" @load="onLoad" finished-text="没有更多了" :finished="isFinished" :immediate-check="false" offset="0">
                <div class="evaluation-wrap">
                    <!--  分类  -->
                    <div class="class-nav-content">
                        <div @click.stop="setActiveNav(item)" class="class-nav-item" :class="{ 'class-nav-item-active': sActiveClassNav === item.key }" v-for="item in arrClassNavList" :key="item.key">
                            <span>{{ item.name }}</span>
                            <span v-if="item.len" class="nav-len">({{ item.len }})</span>
                        </div>
                    </div>
                    <!--      标签      -->
                    <div class="evaluate-tag-content">
                        <div class="tag-box" ref="tagBox" :style="`height: ${arrTagItemHeight[sTagStatus] - 1}px`">
                            <div @click.stop="filterEvaTag(item.id)" v-for="(item, index) in arrTag" :key="index">
                                <div class="tag-item" :class="{ 'active-tag': sSelectTag === item.id }">
                                    {{ item.title }} <span> {{ item.num }}</span>
                                </div>
                            </div>
                        </div>
                        <img class="tag-action" :class="{ 'tag-action-active': sTagStatus !== 'packUp' }" @click.stop="handleTagWind()" :src="require('@/assets/images/project-detail/down-icon.png')" alt="" />
                    </div>
                    <!--     排序       -->
                    <div class="evaluate-order-content">
                        <div class="order-item" @click.stop="changeOrderType">按时间排序</div>
                        <!-- 选择顺序框 -->
                        <div class="order-pop" v-show="isShowOrder">
                            <div class="title" @click.stop="choiceOrder(1)">按时间顺序</div>
                            <div class="title" @click.stop="choiceOrder(0)">按时间倒序</div>
                        </div>
                    </div>
                    <!--     评论列表       -->
                    <div class="evaluate-list-content">
                        <div class="evaluate-item" v-for="(eva, evaIndex) in arrEvaList" :key="evaIndex">
                            <!--        评论基本信息            -->
                            <div class="evaluate-basic-info">
                                <img :src="eva.headimgurl" class="head-image" alt="" />
                                <span class="user-name">{{ eva.username }}</span>
                                <span v-if="eva.self" class="user-self">本案例用户评价</span>
                                <span v-if="eva.selfAdd" class="user-self user-add">追评</span>
                                <span class="eva-time">{{ eva.time }}</span>
                            </div>
                          <div  v-for="(evaContent,evaContentIndex) in eva.evaContent" :key="evaContent.id">
                            <div class="eva-content-wrap" v-if="evaContent.evaValue>3 || evaContentIndex==0 || evaContent.title=='追加评价'">
                                  <!--        大评分            -->
                                <div v-if="evaContent.evaLongTags" class="evaluate-tags-info">
                                    <div class="eva-tag-item" v-for="(item, index) in evaContent.evaLongTags" :key="index">
                                        <div class="key">{{ item.name }}</div>
                                        <div class="start-wrap">
                                            <img class="start-icon" v-for="ite in Number(item.value)" :key="ite" :src="require('@/assets/images/project-detail/start-icon.png')" alt="" />
                                            <img class="start-icon" v-for="ite in 5 - Number(item.value)" :key="ite + 5" :src="require('@/assets/images/project-detail/start-icon-empty.png')" alt="" />
                                            <span>{{ item.value + "分" }} </span>
                                        </div>
                                    </div>
                                </div>
                                <!--            类型标题            -->
                                <div class="type-title" v-if="evaContent.evaContext || evaContent.tags || evaContent.title=='追加评价'"> {{ evaContent.title }}</div>

                                <!--           小评分             -->
                                <div class="eva-small-wrap" v-if="evaContent.evaValue">
                                    <img class="start-icon" v-for="ite in Number(evaContent.evaValue)" :key="ite" :src="require('@/assets/images/project-detail/team-satrt-full.png')" alt="" />
                                    <img class="start-icon" v-for="ite in 5 -Number(evaContent.evaValue)" :key="ite + 5" :src="require('@/assets/images/project-detail/start-icon-empty.png')" alt="" />
                                    <span>{{ evaContent.evaValue + "分" }} </span>
                                </div>

                                <!--        文字评论            -->
                                <p v-if="evaContent.evaContext" class="evaluate-text">{{ evaContent.evaContext }}</p>

                                <!--        语音评价            -->
                                <div v-if="evaContent.audioUrl?true:false" class="evaluate-audio-info" @click.stop="audioClick">
                                    <audio ref="audioRef" class="audio-ref" :src="evaContent.audioUrl" />
                                    <span>{{ evaContent.audioTime?parseInt(evaContent.audioTime):47 }}</span>
                                    <span class="util">&nbsp;s</span>
                                    <div class="audio-icon">
                                        <span class="line" :class="{'line-active':isAudio}" v-for="i in 5" :key="i"></span>
                                    </div>
                                </div>

                                <!--     标签信息         -->
                                <div v-if="evaContent.tags" class="tags-wrap">
                                    <div v-for="item in evaContent.tags" :key="item" class="tag-item">{{ item }}</div>
                                </div>

                                <!--         图片媒体信息           -->
                                <div v-if="evaContent.mateResult" class="evaluate-mate-info">
                                    <div @click="handleImagePreview(evaContent,index)" class="image-box" v-for="(item, index) in evaContent.mateResult" :key="index">
                                        <img v-if="item.type === 'image'" class="image" v-lazy="item.img" alt="" />
                                        <video v-else :poster="item.img + '?x-oss-process=video/snapshot,t_0'" class="image" :src="item.img" alt="" @click="videoPlay(item.img)" />
                                        <!-- <img v-if="item.type === 'video'" @click="videoPlay(item.img)" :src="require('@/assets/images/project-detail/video-icon.png')" alt="" class="icon" /> -->
                                    </div>
                                </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </List>
        </PullRefresh>
        <!-- </pull-to> -->
        <!-- 弹出层 -->
        <van-popup class="pop" v-model="isVideoShow" closeable position="bottom" :style="{ height: '100%'  }">
            <div class="wrapper" v-if="isVideoShow">
                <video :src="sVideoPath" controls></video>
            </div>
        </van-popup>
        <!-- <van-overlay :show="isVideoShow" show-cancel-button width="100%" @click="isVideoShow = false">
           
            </van-overlay> -->
    </div>
</template>

<script>
import { Image, PullRefresh, ImagePreview, List } from "vant";
import { mapState } from "vuex";
import { projectDetailMixin } from "@/page/project/detail/mixin";
import { getEvaluationList, getEvaluationPosteradd, getEvaluationCount } from "@/js/project/evaluation.js"

export default {
    name: "projectDetailevaluationV1",
    created() {
        //console.log("created")
        $init(() => {
            //this.fetchEvaList();
            this.getEvaluationList()
            this.getEvaluationTag()
        })
    },
    components: {
        PullRefresh,
        List,
    },
    mixins: [projectDetailMixin],
    data() {
        return {
            // 标签高度
            arrTagItemHeight: {
                packUp: 0, // 收起
                unwind: 0, // 展开
            },
            // 标签状态
            sTagStatus: "packUp",
            // 音频开始播放
            bAudioStart: false,
            // 刷新标识
            bIsLoading: false,
            isShowOrder: false, //是否展示顺序选择框
            isAudio: false,//是否播放评价语音
            arrTag: [], //评论标签
            sSelectTag: "", //选中的标签
            arrClassNavList: [],//导航
            sActiveClassNav: "",//选中的导航
            arrEvaList: [],//评论列表
            sOrder: "",
            sVideoPath: "",
            isVideoShow: false,
            nPage: 0,
            nLimit: 10,
            isFinished: false,
            isLoading: false,
            isRepeat:true,//防止请求多次接口,该函数被多次触发
        };
    },
    computed: {
        ...mapState({
            // 分类导航
            //arrClassNavList: (state) => state.evaluation.arrClassNavList,
            // 激活的分类导航
            //sActiveClassNav: (state) => state.evaluation.sActiveClassNav,
            // 评论标签
            //arrEvaTag: (state) => state.evaluation.arrEvaTag,
            // 当前激活的标签
            //sActiveTagKey: (state) => state.evaluation.sActiveTagKey,
            // 当前的排序方式
            //sActiveOrder: (state) => state.evaluation.sActiveOrder,
        }),
        // 评论标签数量
        evaTagCount() {
            return this.$store.getters["projectDetailEvaluation/evaTagCount"];
        },
        // 评论列表
        // arrEvaList() {
        //     return this.$store.getters["evaluation/evaFilterList"];
        // },
    },
    mounted() {
        // this.saveTagBoxHeight();
    },
    methods: {
        /**
         * 保存标签的高度
         */
        saveTagBoxHeight() {
          
          this.isRepeat=false//防止请求多次接口,该函数被多次触发
            this.$nextTick(() => {
                const el = this.$refs.tagBox;
                const childNodes = el.childNodes
                this.arrTagItemHeight.packUp = el.childNodes[0].clientHeight;
                const wCount = Math.floor(el.clientWidth / el.childNodes[0].clientWidth);
                const hCount = Math.ceil(this.arrTag?.length / wCount);
                this.arrTagItemHeight.unwind = hCount * this.arrTagItemHeight.packUp;
                el.style.height = this.arrTagItemHeight.packUp + "px";
            });
        },
        audioClick() {
            const audio = this.$refs.audioRef[0];
            audio.paused ? audio.play() : audio.pause();
            if (audio.paused) {
                // console.log("语音动态关");
                this.isAudio = false
            } else {
                // console.log("语音动态开");
                this.isAudio = true
            }
        },
        /**
         * 请求评论数据
         * @param labKey
         */
        fetchEvaList(labKey) {
            this.$store.dispatch({ type: "projectDetailEvaluation/fetchEvaluateList", labKey });
        },
        /**
         * 处理标签伸缩
         */
        handleTagWind() {
            const keys = Object.keys(this.arrTagItemHeight);
            this.sTagStatus = this.sTagStatus === keys[0] ? keys[1] : keys[0];
            console.log(this.arrTagItemHeight)
        },
        /**
         * 改变激活的菜单
         * @param  item
         */
        setActiveNav(item) {
            //this.$store.commit({ type: "evaluation/CHANGE_ACTIVE_NAV", name: item.name });
            //this.fetchEvaList(item.key);
            //console.log(item)
            if (item.key != this.sActiveClassNav) {
                this.sActiveClassNav = item.key
            } else {
                this.sActiveClassNav = ""
            }
            this.arrEvaList = []
            this.nPage = 0
            this.getEvaluationList()
        },
        /**
         * 下拉刷新
         */
        onRefresh() {
            // const timer = setTimeout(() => {
            //     this.bIsLoading = !this.bIsLoading;
            //     clearTimeout(timer);
            // }, 1000);
            this.nPage = 0
            this.arrEvaList = []
            this.getEvaluationList()
        },
        /**
         * 图片预览
         * @param item
         */
        handleImagePreview(arr, index) {
            //console.log(arr,index)
            if (arr.mateResult[index].type === "image") {
                let arrImage = []
                //let data = JSON.parse(JSON.stringify(arr.mateResult))
                //   const { type, img } = item;
                //console.log(data)
                arr.mateResult.forEach(item => {
                    //过滤video
                    // console.log(item)
                    if (item.type === "image") {
                        arrImage.push(item.img)
                    }
                })
                //console.log(arrImage)
                //let str = data[index].img
                //arrImage.splice(index, 1)
                //arrImage.splice(0, 0, str)
                ImagePreview(arrImage,index);
            }

            //   switch (type) {
            //     case "image":
            //       ImagePreview([img]);
            //       break;
            //     case "video":
            //       break;
            //   }
        },
        /**
         * 过滤评论key
         * @param key
         */
        filterEvaTag(key) {
            //this.$store.commit({ type: "evaluation/CHANGE_ACTIVE_TAG_KEY", key });
            if (this.sSelectTag != key) {
                this.sSelectTag = key
            } else {
                this.sSelectTag = ""
            }
            this.nPage = 0
            this.arrEvaList = []
            this.getEvaluationList()
        },
        // 选择排序方法
        choiceOrder(val) {
            this.isShowOrder = false;
            this.sOrder = val
            this.arrEvaList = []
            this.nPage = 0
            this.getEvaluationList()
        },
        /**
         * 改变排序方式
         * @param type
         */
        changeOrderType() {
            // up / down 升降序
            // const key = this.sActiveOrder === "up" ? "down" : "up";
            // this.$store.commit({ type: "evaluation/CHANGE_ACTIVE_ORDER_TYPE", key });
            this.isShowOrder = !this.isShowOrder;
        },
        getEvaluationTag() {
            getEvaluationCount().then(res => {
                //console.log(res)
                let result = res.data.result
                this.arrTag = result.tags
                //console.log(this.arrTag)
                this.arrClassNavList = []
                this.arrClassNavList.push({ name: "全部", key: "all", len: result.count, })
                this.arrClassNavList.push({ name: "有图/视频", key: "mate", len: result.pic, })
                this.arrClassNavList.push({ name: "追加", key: "add", len: result.dis, })
                //console.log(this.arrClassNavList)
            })
        },
        getEvaluationList() {
            let data = {
                //topic_id: "318",
                page: this.nPage,
                size: this.nLimit,
                tag: this.sSelectTag,
                type: this.sActiveClassNav == "mate" ? "1" : "",
                superaddition: this.sActiveClassNav == "add" ? "1" : "",
                order: this.sOrder
            }
            // getEvaluationList(data).then(res => {
            //     console.log(res)

            // })
            getEvaluationPosteradd(data).then(res => {
                let result = res.data.result
                //console.log(result)
                this.isLoading = false
                this.bIsLoading = false;
                this.arrEvaList = this.arrEvaList.concat(result)
                // 处理数据
                 this.arrEvaList= this.arrEvaList.map(item=>{
                   item.time=item.time.split(" ")[0]
                   return item
                 })
                if (result.length < this.nLimit) {
                    this.isFinished = true

                } else {
                    this.isFinished = false
                }
                // 在需要for循环渲染的数据赋值之后再获取节点信息，否则就拿不到所需的节点数据
                //isRepeat防止请求多次接口,该函数被多次触发
                setTimeout(()=>{
                  if(this.isRepeat){
                      this.saveTagBoxHeight();
                }
                },10)
                
            })

        },
        videoPlay(val) {
            this.sVideoPath = val
            this.isVideoShow = true
        },
        onLoad() {
            this.debounce(() => {
                // console.log("onLoad")
                this.nPage++
                this.getEvaluationList()
            }, 300)
        },
        debounce(fn, delay) {
            let context = this; // this指向发生变化，需要提出来
            let args = arguments;
            return (function () {
                if (context.timer) {
                    clearTimeout(context.timer);
                }
                context.timer = setTimeout(() => {
                    fn.apply(context, args);
                }, delay);
            })(); // 注意:我加了()
        },

    },
};
</script>

<style scoped lang="scss">
.evaluation-page {
    min-height: 100vh;
    padding: 24px 20px 180px;
    color: $defaultBlack;
    font-size: $baseSize;

    .evaluation-wrap {
        box-shadow: $boxShadow;
        border-radius: 10px;
        padding: 32px 20px 0;

        .class-nav-content {
            display: flex;
            align-items: center;
            font-size: $baseSize;
            margin-bottom: 30px;

            .class-nav-item {
                margin-right: 40px;
                line-height: 36px;
                display: flex;
                align-items: center;

                img {
                    width: 38px;
                    height: 38px;
                    margin-right: 6px;
                }

                .nav-len {
                    color: rgba(#434343, 0.5);
                    font-size: $baseSize;
                    margin-left: 10px;
                }
            }

            .class-nav-item-active {
                color: $defaultGreen;
                font-weight: 700;

                .nav-len {
                    color: $defaultGreen;
                }
            }
        }

        .evaluate-tag-content {
            padding-bottom: 12px;
            border-bottom: 1px solid #dcdcdc;
            margin-bottom: 24px;
            font-size: $smallSize;

            .tag-box {
                margin-bottom: 14px;
                min-height: 150px;
                display: flex;
                flex-wrap: wrap;
                overflow: hidden;
                transition: height 0.5s;

                .tag-item {
                    padding: 0 24px;
                    height: 60px;
                    line-height: 60px;
                    background: rgba(#328444, 0.1);
                    color: #739e82;
                    border-radius: $commonRadius;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-bottom: 16px;
                    margin-right: 16px;
                }

                .active-tag {
                    background: $defaultGreen;
                    color: #ffffff;
                }
            }

            .tag-action {
                width: 38px;
                height: 38px;
                display: block;
                margin: 0 auto;
                transition: all 0.5s;
            }

            .tag-action-active {
                transform: rotate(180deg);
            }
        }

        .evaluate-order-content {
            display: flex;
            justify-content: flex-end;
            align-items: center;
            padding-bottom: 24px;
            position: relative;

            .order-item {
                line-height: 26px;
                font-size: 26px;
                color: #555555;
            }
            .order-pop {
                position: absolute;
                height: 120px;
                background: #ffffff;
                top: 40px;
                right: 0;
                padding: 0 20px;
                border: 1px solid rgba(168,168,168,0.2);
                .title {
                    font-size: 25px;
                    color: #555555;
                    height: 55px;
                    line-height: 55px;
                    text-align: right;
                    &:nth-child(1) {
                          border-bottom: 1px dashed  rgba(168,168,168,0.2);
                    }
                }
            }
        }

        .evaluate-list-content {
            font-size: $bigSize;

            .evaluate-item {
                padding: 0 0 28px;
                border-bottom: 1px solid rgba($defaultGary, 0.3);
                margin-bottom: 20px;

                &:last-child {
                    border-bottom-color: transparent;
                }

                .evaluate-basic-info {
                    display: flex;
                    font-size: 22px;
                    align-items: center;

                    .head-image {
                        width: 62px;
                        height: 62px;
                        margin-right: 18px;
                        border-radius: 100%;
                    }

                    .user-name {
                        font-size: 30px;
                        font-weight: 600;
                        margin-right: 14px;
                    }

                    .user-self {
                        padding: 0 12px;
                        line-height: 32px;
                        text-align: center;
                        background: rgba(#328444, 0.1);
                        border-radius: 32px;
                        color: $defaultGreen;
                    }

                    .user-add {
                        background: $defaultGreen;
                        color: #ffffff;
                        font-size: 22px;
                        margin-left: 10px;
                    }

                    .eva-time {
                        flex: 1;
                        text-align: right;
                        color: rgba(#2d2d2d, 0.5);
                    }
                }

                .eva-content-wrap {
                    padding: 24px 0 2px;
                    background: linear-gradient(
                            to right,
                            #f1f1f1 50%,
                            transparent 50%
                        )
                        repeat-x bottom left / 20px 2px;

                    &:last-of-type {
                        background: none;
                    }

                    .evaluate-tags-info {
                        font-size: $baseSize;

                        .eva-tag-item {
                            display: flex;
                            line-height: 40px;
                            margin-bottom: 20px;

                            &:last-child {
                                margin-bottom: 32px;
                            }

                            .key {
                                flex: 0 0 auto;
                                width: max-content;
                                color: #858585;
                                display: inline-flex;
                                justify-content: space-between;
                                margin-right: 20px;
                            }

                            .start-wrap {
                                display: flex;
                                align-items: center;

                                .start-icon {
                                    width: 32px;
                                    height: 32px;
                                    margin-right: 32px;
                                }

                                span {
                                    color: #858585;
                                    font-size: $smallSize;
                                }
                            }
                        }
                    }

                    .evaluate-text {
                        margin-bottom: 20px;
                        line-height: 40px;
                        font-size: $baseSize;
                    }

                    .type-title {
                        line-height: 40px;
                        font-size: $baseSize;
                        font-weight: 500;
                        color: $commonText;
                        margin-bottom: 20px;
                    }

                    .evaluate-audio-info {
                        margin-bottom: 32px;
                        width: 514px;
                        height: 68px;
                        background: url("../../../../assets/images/project-detail/audio-back-2.png")
                            no-repeat left center / contain;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                        padding: 0 30px;
                        color: #6c9276;
                        font-size: 34px;

                        .audio-ref {
                            position: absolute;
                            z-index: -1;
                        }

                        .audio-icon {
                            height: 32px;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .line {
                                height: 80%;
                                background: #6c9276;
                                width: 2px;
                                margin-right: 2px;

                                &:nth-child(1),
                                &:nth-child(5) {
                                    height: 20%;
                                }

                                &:nth-child(2),
                                &:nth-child(4) {
                                    height: 50%;
                                }

                                &:last-child {
                                    margin: 0;
                                }
                            }
                            .line-active {
                                height: 80%;
                                animation: centerLine 0.9s infinite;
                                &:nth-child(1),
                                &:nth-child(5) {
                                    height: 20%;
                                    animation: leftLine 1s infinite;
                                }
                                &:nth-child(2),
                                &:nth-child(4) {
                                    height: 50%;
                                    animation: rightLines 1s infinite;
                                }
                            }
                            @keyframes centerLine {
                                0% {
                                    height: 80%;
                                }
                                50% {
                                    height: 50%;
                                }
                                100% {
                                    height: 80%;
                                }
                            }
                            @keyframes leftLine {
                                0% {
                                    height: 20%;
                                }
                                25% {
                                    height: 30%;
                                }
                                50% {
                                    height: 10%;
                                }
                                100% {
                                    height: 20%;
                                }
                            }
                            @keyframes rightLine {
                                0% {
                                    height: 50%;
                                }
                                25% {
                                    height: 60%;
                                }
                                50% {
                                    height: 40%;
                                }
                                100% {
                                    height: 50%;
                                }
                            }
                        }

                        .util {
                            font-size: $smallSize;
                            padding-right: 20px;
                        }
                    }

                    .eva-small-wrap {
                        display: flex;
                        align-items: center;
                        margin-bottom: 28px;

                        .start-icon {
                            width: 28px;
                            height: 28px;
                            margin-right: 20px;
                        }

                        span {
                            color: #858585;
                            font-size: $smallSize;
                        }
                    }

                    .tags-wrap {
                        display: flex;
                        align-items: center;
                        flex-wrap: wrap;
                        margin-bottom: 28px;

                        .tag-item {
                            padding: 12px 16px;
                            border-radius: $commonRadius;
                            line-height: 32px;
                            font-size: $smallSize;
                            color: $deepGreen;
                            background: #eaf1ef;
                            margin-right: 12px;
                            margin-bottom: 10px;
                        }
                    }

                    .evaluate-mate-info {
                        display: flex;
                        flex-wrap: wrap;

                        .image-box {
                            position: relative;
                            margin-bottom: 20px;
                            margin-right: 20px;
                            width: 144px;
                            height: 144px;
                            overflow: hidden;
                            border-radius: 10px;
                            display: flex;
                            justify-content: center;
                            align-items: center;

                            &:nth-child(n + 3) {
                                //margin-right: 0;
                            }

                            .image {
                                display: block;
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }

                            .icon {
                                position: absolute;
                                width: 60px;
                                height: 60px;
                            }
                        }
                    }
                }
            }
        }
    }
}
.wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;

    video {
        width: 100%;
        height: 100%;
    }
}
.pop {
    background-color: transparent;
}
</style>
